module.exports = __webpack_public_path__ + "images/spoticar_smallbf5c548ffa8b2a1e5ead4b5abe0ea894.png";